export default "__VITE_ASSET__022c57c2__"